import React, { useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

// styles

const StyledAccordionPanel = styled.div<{ isHeaderClickable: boolean }>`
  border: 2px solid #ccc;
  border-radius: 7px;

  .header-container {
    display: flex;
    padding: 1%;
    border-radius: 5px;
  }

  .header {
    padding: 0 1% 0 1%;
    width: 100%;
    align-items: center;
  }

  .header-content{
    width: fit-content;
     cursor:  ${({ isHeaderClickable }) => (isHeaderClickable ? 'pointer' : 'default')};
  }

  .content {
    border-top: 2px solid;
    border-color: #ccc;
    padding: 1%;
  }

  .toggle-icon {
    align-self: center;
    outline: none;
  }
`;

// props
export interface AccordionPanelProps {
  id: string;
  onToggle?(isExpanded: boolean): void;
  isExpandable?: boolean;
  isInitialExpanded?: boolean;
  isLeftToggle?: boolean;
  expandedIcon?: IconProp;
  collapsedIcon?: IconProp;
  header: React.ReactNode;
  children: React.ReactNode;
  isHeaderClickable?: boolean
}

const AccordionPanel = ({
  isInitialExpanded = false,
  isExpandable = true,
  isLeftToggle = false,
  collapsedIcon = 'chevron-down',
  expandedIcon = 'chevron-up',
  header,
  children,
  onToggle: onToggleFromProp,
  isHeaderClickable = false,
}: AccordionPanelProps) => {
  const [expanded, setExpanded] = useState(isInitialExpanded);
  const HeaderComponent = header;

  const onToggle = (e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    setExpanded(!expanded);
    onToggleFromProp && onToggleFromProp(expanded);
  };

  return (
    <StyledAccordionPanel className='accordion-panel-component' isHeaderClickable={isHeaderClickable}>
      <div className='header-container'>
        {isLeftToggle && isExpandable ? (
          <a
            className='gi-panel__toggle toggle-icon'
            href='#'
            onClick={onToggle}
          >
            <FontAwesomeIcon
              icon={expanded ? expandedIcon : collapsedIcon}
              className='grid-col-1'
            />
          </a>
        ) : (
          ''
        )}
        <div className='header'><div className='header-content' onClick={isHeaderClickable ? onToggle : undefined}>{HeaderComponent}</div></div>
        {isLeftToggle === false && isExpandable ? (
          <a
            className='gi-panel__toggle toggle-icon'
            href='#'
            onClick={onToggle}
          >
            <FontAwesomeIcon
              icon={expanded ? expandedIcon : collapsedIcon}
              className='grid-col-1 icon'
            />
          </a>
        ) : (
          ''
        )}
      </div>
      {expanded && <div className='content'>{children}</div>}
    </StyledAccordionPanel>
  );
};

export default AccordionPanel;
